<div class="page-layout blank" fxLayout="column">
  
      <div style="height: 100%;">
        <div #dashboardContainer id="dashboardContainer"></div>
      </div>
      
  </div>
  